var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Leave",
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.643,
    height: 88.706,
    viewBox: "0 0 86.643 88.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5400",
    "data-name": "Path 5400",
    d: "M76.014,81.144A10.622,10.622,0,1,1,86.644,70.519,10.622,10.622,0,0,1,76.014,81.144Zm0-18.2A7.576,7.576,0,1,0,83.6,70.522,7.576,7.576,0,0,0,76.014,62.948Z",
    transform: "translate(-58.368 -52.876)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5401",
    "data-name": "Path 5401",
    d: "M114.683,28.865a1.523,1.523,0,0,1-1.523-1.523V24.523a1.523,1.523,0,1,1,3.046,0v2.819A1.523,1.523,0,0,1,114.683,28.865Z",
    transform: "translate(-97.037 -23)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5402",
    "data-name": "Path 5402",
    d: "M56.781,52.848A1.523,1.523,0,0,1,55.7,52.4L53.711,50.41a1.523,1.523,0,1,1,2.153-2.155l1.995,1.993a1.523,1.523,0,0,1-1.077,2.6Z",
    transform: "translate(-48.542 -43.087)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5403",
    "data-name": "Path 5403",
    d: "M32.8,110.746H29.983a1.523,1.523,0,1,1,0-3.046H32.8a1.523,1.523,0,1,1,0,3.046Z",
    transform: "translate(-28.46 -91.577)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5404",
    "data-name": "Path 5404",
    d: "M54.788,162.164a1.523,1.523,0,0,1-1.077-2.6l1.993-1.993a1.523,1.523,0,1,1,2.155,2.153l-1.995,1.993A1.51,1.51,0,0,1,54.788,162.164Z",
    transform: "translate(-48.542 -131.593)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5405",
    "data-name": "Path 5405",
    d: "M114.683,183.465a1.523,1.523,0,0,1-1.523-1.523v-2.819a1.523,1.523,0,0,1,3.046,0v2.819A1.523,1.523,0,0,1,114.683,183.465Z",
    transform: "translate(-97.037 -148.171)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5406",
    "data-name": "Path 5406",
    d: "M166.217,162.282a1.511,1.511,0,0,1-1.076-.447l-1.993-1.993a1.523,1.523,0,0,1,2.153-2.153l1.993,1.993a1.523,1.523,0,0,1-1.077,2.6Z",
    transform: "translate(-137.171 -131.711)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5407",
    "data-name": "Path 5407",
    d: "M187.4,110.746h-2.817a1.523,1.523,0,0,1,0-3.046H187.4a1.523,1.523,0,1,1,0,3.046Z",
    transform: "translate(-153.631 -91.577)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5408",
    "data-name": "Path 5408",
    d: "M164.106,52.962a1.523,1.523,0,0,1-1.076-2.6l1.993-1.993a1.523,1.523,0,0,1,2.153,2.153l-1.993,1.995A1.523,1.523,0,0,1,164.106,52.962Z",
    transform: "translate(-137.052 -43.2)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5409",
    "data-name": "Path 5409",
    d: "M122.849,280.416H55.185a9.708,9.708,0,0,1-9.152-6.51l-5.787-16.591a5.731,5.731,0,1,1,10.826-3.765l3.79,10.925a6.663,6.663,0,0,0,6.282,4.473h61.706a1.523,1.523,0,0,1,1.523,1.523v8.423a1.523,1.523,0,0,1-1.523,1.523ZM45.662,252.742a2.69,2.69,0,0,0-2.539,3.571L48.9,272.9a6.662,6.662,0,0,0,6.282,4.468h66.145v-5.378H61.153a9.708,9.708,0,0,1-9.164-6.522L48.2,254.549a2.688,2.688,0,0,0-2.536-1.806Z",
    transform: "translate(-37.745 -206.544)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5410",
    "data-name": "Path 5410",
    d: "M140.444,412.945h-6.925a1.523,1.523,0,0,1-1.391-2.143l6.615-14.834a1.524,1.524,0,1,1,2.783,1.241L135.874,409.9h3.583l6.209-13.932a1.524,1.524,0,1,1,2.783,1.241l-6.613,14.834A1.523,1.523,0,0,1,140.444,412.945Z",
    transform: "translate(-112.287 -324.239)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5411",
    "data-name": "Path 5411",
    d: "M367.739,412.945h-6.919a1.523,1.523,0,0,1-1.39-.9l-6.613-14.834a1.524,1.524,0,1,1,2.783-1.241l6.209,13.932h3.583l-5.659-12.691a1.523,1.523,0,1,1,2.781-1.241l6.615,14.835a1.523,1.523,0,0,1-1.39,2.143Z",
    transform: "translate(-290.966 -324.239)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5412",
    "data-name": "Path 5412",
    d: "M252.143,134.434a1.523,1.523,0,0,1-1.523-1.523,23.978,23.978,0,0,0-47.955-.16,1.523,1.523,0,0,1-1.523,1.523h-.01a1.523,1.523,0,0,1-1.513-1.532,27.031,27.031,0,0,1,54.061.179,1.523,1.523,0,0,1-1.538,1.513Z",
    transform: "translate(-167.038 -90.111)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5413",
    "data-name": "Path 5413",
    d: "M303,134.426a1.523,1.523,0,0,1-1.523-1.523,50.211,50.211,0,0,0-2.787-17.482c-1.572-4.068-3.649-6.495-5.555-6.495s-3.98,2.427-5.555,6.495A50.2,50.2,0,0,0,284.8,132.9a1.523,1.523,0,1,1-3.046,0,53.3,53.3,0,0,1,2.992-18.581c2.105-5.444,5.088-8.442,8.395-8.442s6.282,3,8.395,8.442a53.256,53.256,0,0,1,2.992,18.581A1.523,1.523,0,0,1,303,134.426Z",
    transform: "translate(-233.535 -90.103)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5414",
    "data-name": "Path 5414",
    d: "M216.767,209.148a1.523,1.523,0,0,1-1.523-1.523,6.3,6.3,0,0,0-12.59-.133,1.523,1.523,0,1,1-3.046-.076,9.341,9.341,0,1,1,18.68.19,1.523,1.523,0,0,1-1.514,1.523Z",
    transform: "translate(-167.028 -164.825)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M402.557,209.148a1.523,1.523,0,0,1-1.523-1.523,6.3,6.3,0,0,0-12.59-.133,1.523,1.523,0,0,1-1.523,1.485h-.04a1.523,1.523,0,0,1-1.483-1.561,9.341,9.341,0,1,1,18.68.19,1.523,1.523,0,0,1-1.523,1.523Z",
    transform: "translate(-317.452 -164.825)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M302.992,209.82a1.523,1.523,0,0,1-1.523-1.511A5.551,5.551,0,0,0,299.156,204a9.709,9.709,0,0,0-6.03-1.961c-4.492,0-8.235,2.754-8.343,6.143a1.524,1.524,0,0,1-3.046-.1C281.9,203,286.9,199,293.126,199a12.765,12.765,0,0,1,7.923,2.619,8.551,8.551,0,0,1,3.466,6.662A1.523,1.523,0,0,1,303,209.814Z",
    transform: "translate(-233.523 -165.497)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M335.093,230.944a1.523,1.523,0,0,1-1.523-1.523v-28.9a1.523,1.523,0,0,1,3.046,0v28.9A1.523,1.523,0,0,1,335.093,230.944Z",
    transform: "translate(-275.49 -165.497)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M335.093,80.054a1.523,1.523,0,0,1-1.523-1.523V71.743a1.523,1.523,0,0,1,3.046,0v6.788A1.523,1.523,0,0,1,335.093,80.054Z",
    transform: "translate(-275.49 -61.231)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M109.853,310.768a1.523,1.523,0,0,1-1.523-1.523,8.619,8.619,0,0,0-8.608-8.61h-3.8a1.523,1.523,0,1,1,0-3.046H99.73a11.667,11.667,0,0,1,11.654,11.656,1.523,1.523,0,0,1-1.53,1.523Z",
    transform: "translate(-81.848 -245.32)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacation);
export default __webpack_public_path__ + "static/media/vacation.9706f15c989cf3f5fa185395946afa82.svg";
export { ForwardRef as ReactComponent };